// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilePdfFilledSvg from "@ant-design/icons-svg/es/asn/FilePdfFilled";
import AntdIcon from '../components/AntdIcon';

var FilePdfFilled = function FilePdfFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilePdfFilledSvg
  }));
};

FilePdfFilled.displayName = 'FilePdfFilled';
export default React.forwardRef(FilePdfFilled);